import { render, staticRenderFns } from "./ClipForm.vue?vue&type=template&id=b55e72ce"
import script from "./ClipForm.vue?vue&type=script&lang=js"
export * from "./ClipForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports